import { render, staticRenderFns } from "./VtDataTable.vue?vue&type=template&id=b759a9a4"
import script from "./VtDataTable.vue?vue&type=script&lang=js"
export * from "./VtDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports